import SymbolBnbxLight from '../logos/symbol/BnbxLight.svg';
import SymbolEthxLight from '../logos/symbol/EthxLight.svg';
import SymbolMaticxLight from '../logos/symbol/MaticxLight.svg';
import SymbolSlight from '../logos/symbol/SLight.svg';
import SymbolAave from '../logos/symbol/Aave.svg';
import SymbolUsd from '../logos/symbol/Usd.svg';
import SymbolAda from '../logos/symbol/Ada.svg';
import SymbolAero from '../logos/symbol/Aero.svg';
import SymbolAgEth from '../logos/symbol/Ageth.svg';
import SymbolRsEth from '../logos/symbol/Rseth.svg';
import SymbolAlgo from '../logos/symbol/Algo.svg';
import SymbolAnkr from '../logos/symbol/Ankr.svg';
import SymbolAnkrEth from '../logos/symbol/Ankreth.svg';
import SymbolEth from '../logos/symbol/Eth.svg';
import SymbolApe from '../logos/symbol/Ape.svg';
import SymbolApi3 from '../logos/symbol/Api3.svg';
import SymbolApt from '../logos/symbol/Apt.svg';
import SymbolApxEth from '../logos/symbol/Apxeth.svg';
import SymbolPxEth from '../logos/symbol/Pxeth.svg';
import SymbolAr from '../logos/symbol/Ar.svg';
import SymbolArb from '../logos/symbol/Arb.svg';
import SymbolAstr from '../logos/symbol/Astr.svg';
import SymbolAtom from '../logos/symbol/Atom.svg';
import SymbolAusd from '../logos/symbol/Ausd.svg';
import SymbolAvax from '../logos/symbol/Avax.svg';
import SymbolAxl from '../logos/symbol/Axl.svg';
import SymbolAxs from '../logos/symbol/Axs.svg';
import SymbolBal from '../logos/symbol/Bal.svg';
import SymbolBand from '../logos/symbol/Band.svg';
import SymbolBat from '../logos/symbol/Bat.svg';
import SymbolBera from '../logos/symbol/Bera.svg';
import SymbolBlast from '../logos/symbol/Blast.svg';
import SymbolBlur from '../logos/symbol/Blur.svg';
import SymbolBnb from '../logos/symbol/Bnb.svg';
import SymbolBnbx from '../logos/symbol/Bnbx.svg';
import SymbolBrett from '../logos/symbol/Brett.svg';
import SymbolBtc from '../logos/symbol/Btc.svg';
import SymbolCake from '../logos/symbol/Cake.svg';
import SymbolCbBtc from '../logos/symbol/Cbbtc.svg';
import SymbolCbEth from '../logos/symbol/Cbeth.svg';
import SymbolCelo from '../logos/symbol/Celo.svg';
import SymbolCfx from '../logos/symbol/Cfx.svg';
import SymbolChz from '../logos/symbol/Chz.svg';
import SymbolCmEth from '../logos/symbol/Cmeth.svg';
import SymbolMeth from '../logos/symbol/Meth.svg';
import SymbolComp from '../logos/symbol/Comp.svg';
import SymbolCook from '../logos/symbol/Cook.svg';
import SymbolCore from '../logos/symbol/Core.svg';
import SymbolCro from '../logos/symbol/Cro.svg';
import SymbolCrv from '../logos/symbol/Crv.svg';
import SymbolCrvUsd from '../logos/symbol/Crvusd.svg';
import SymbolCvx from '../logos/symbol/Cvx.svg';
import SymbolDai from '../logos/symbol/Dai.svg';
import SymbolDegen from '../logos/symbol/Degen.svg';
import SymbolDoge from '../logos/symbol/Doge.svg';
import SymbolDot from '../logos/symbol/Dot.svg';
import SymbolDydx from '../logos/symbol/Dydx.svg';
import SymbolDym from '../logos/symbol/Dym.svg';
import SymbolEbtc from '../logos/symbol/Ebtc.svg';
import SymbolWbtc from '../logos/symbol/Wbtc.svg';
import SymbolEgEth from '../logos/symbol/Egeth.svg';
import SymbolEna from '../logos/symbol/Ena.svg';
import SymbolEns from '../logos/symbol/Ens.svg';
import SymbolEthfi from '../logos/symbol/Ethfi.svg';
import SymbolEthx from '../logos/symbol/Ethx.svg';
import SymbolEur from '../logos/symbol/Eur.svg';
import SymbolEurc from '../logos/symbol/Eurc.svg';
import SymbolEure from '../logos/symbol/Eure.svg';
import SymbolEzEth from '../logos/symbol/Ezeth.svg';
import SymbolFbtc from '../logos/symbol/Fbtc.svg';
import SymbolFdusd from '../logos/symbol/Fdusd.svg';
import SymbolFil from '../logos/symbol/Fil.svg';
import SymbolFlow from '../logos/symbol/Flow.svg';
import SymbolFrax from '../logos/symbol/Frax.svg';
import SymbolFrxUsd from '../logos/symbol/Frxusd.svg';
import SymbolFxs from '../logos/symbol/Fxs.svg';
import SymbolGho from '../logos/symbol/Gho.svg';
import SymbolGlmr from '../logos/symbol/Glmr.svg';
import SymbolGmx from '../logos/symbol/Gmx.svg';
import SymbolGno from '../logos/symbol/Gno.svg';
import SymbolGns from '../logos/symbol/Gns.svg';
import SymbolGrt from '../logos/symbol/Grt.svg';
import SymbolHbar from '../logos/symbol/Hbar.svg';
import SymbolHnt from '../logos/symbol/Hnt.svg';
import SymbolHype from '../logos/symbol/Hype.svg';
import SymbolIcp from '../logos/symbol/Icp.svg';
import SymbolImx from '../logos/symbol/Imx.svg';
import SymbolInEth from '../logos/symbol/Ineth.svg';
import SymbolInj from '../logos/symbol/Inj.svg';
import SymbolInsfrxEth from '../logos/symbol/Insfrxeth.svg';
import SymbolSfrxEth from '../logos/symbol/Sfrxeth.svg';
import SymbolInstEth from '../logos/symbol/Insteth.svg';
import SymbolStEth from '../logos/symbol/Steth.svg';
import SymbolInwstEths from '../logos/symbol/Inwsteths.svg';
import SymbolWstEth from '../logos/symbol/Wsteth.svg';
import SymbolJoe from '../logos/symbol/Joe.svg';
import SymbolKava from '../logos/symbol/Kava.svg';
import SymbolKda from '../logos/symbol/Kda.svg';
import SymbolKsm from '../logos/symbol/Ksm.svg';
import SymbolLbtc from '../logos/symbol/Lbtc.svg';
import SymbolLdo from '../logos/symbol/Ldo.svg';
import SymbolLink from '../logos/symbol/Link.svg';
import SymbolLqty from '../logos/symbol/Lqty.svg';
import SymbolLsEth from '../logos/symbol/Lseth.svg';
import SymbolLtc from '../logos/symbol/Ltc.svg';
import SymbolLumia from '../logos/symbol/Lumia.svg';
import SymbolLusd from '../logos/symbol/Lusd.svg';
import SymbolMana from '../logos/symbol/Mana.svg';
import SymbolManta from '../logos/symbol/Manta.svg';
import SymbolMask from '../logos/symbol/Mask.svg';
import SymbolMaticx from '../logos/symbol/Maticx.svg';
import SymbolMatic from '../logos/symbol/Matic.svg';
import SymbolMerl from '../logos/symbol/Merl.svg';
import SymbolMetis from '../logos/symbol/Metis.svg';
import SymbolMkr from '../logos/symbol/Mkr.svg';
import SymbolMnt from '../logos/symbol/Mnt.svg';
import SymbolMode from '../logos/symbol/Mode.svg';
import SymbolMorpho from '../logos/symbol/Morpho.svg';
import SymbolMovr from '../logos/symbol/Movr.svg';
import SymbolMstEth from '../logos/symbol/Msteth.svg';
import SymbolMtl from '../logos/symbol/Mtl.svg';
import SymbolMvl from '../logos/symbol/Mvl.svg';
import SymbolNear from '../logos/symbol/Near.svg';
import SymbolNeon from '../logos/symbol/Neon.svg';
import SymbolOkb from '../logos/symbol/Okb.svg';
import SymbolOndo from '../logos/symbol/Ondo.svg';
import SymbolOp from '../logos/symbol/Op.svg';
import SymbolOrdi from '../logos/symbol/Ordi.svg';
import SymbolOsEth from '../logos/symbol/Oseth.svg';
import SymbolOsmo from '../logos/symbol/Osmo.svg';
import SymbolPaxg from '../logos/symbol/Paxg.svg';
import SymbolPendle from '../logos/symbol/Pendle.svg';
import SymbolPol from '../logos/symbol/Pol.svg';
import SymbolPufEth from '../logos/symbol/Pufeth.svg';
import SymbolPyth from '../logos/symbol/Pyth.svg';
import SymbolPyusd from '../logos/symbol/Pyusd.svg';
import SymbolQuick from '../logos/symbol/Quick.svg';
import SymbolRari from '../logos/symbol/Rari.svg';
import SymbolRdnt from '../logos/symbol/Rdnt.svg';
import SymbolRender from '../logos/symbol/Render.svg';
import SymbolResolv from '../logos/symbol/Resolv.svg';
import SymbolReth from '../logos/symbol/Reth.svg';
import SymbolRif from '../logos/symbol/Rif.svg';
import SymbolRon from '../logos/symbol/Ron.svg';
import SymbolRose from '../logos/symbol/Rose.svg';
import SymbolRpl from '../logos/symbol/Rpl.svg';
import SymbolRsr from '../logos/symbol/Rsr.svg';
import SymbolRswEth from '../logos/symbol/Rsweth.svg';
import SymbolRune from '../logos/symbol/Rune.svg';
import SymbolS from '../logos/symbol/S.svg';
import SymbolSafe from '../logos/symbol/Safe.svg';
import SymbolSand from '../logos/symbol/Sand.svg';
import SymbolSats from '../logos/symbol/Sats.svg';
import SymbolSavax from '../logos/symbol/Savax.svg';
import SymbolScr from '../logos/symbol/Scr.svg';
import SymbolScrvUsd from '../logos/symbol/Scrvusd.svg';
import SymbolSdai from '../logos/symbol/Sdai.svg';
import SymbolSei from '../logos/symbol/Sei.svg';
import SymbolSfrax from '../logos/symbol/Sfrax.svg';
import SymbolFrxEth from '../logos/symbol/Frxeth.svg';
import SymbolSfrxUsd from '../logos/symbol/Sfrxusd.svg';
import SymbolShib from '../logos/symbol/Shib.svg';
import SymbolSlisBnb from '../logos/symbol/Slisbnb.svg';
import SymbolSnx from '../logos/symbol/Snx.svg';
import SymbolSol from '../logos/symbol/Sol.svg';
import SymbolSolvBtc from '../logos/symbol/Solvbtc.svg';
import SymbolSpk from '../logos/symbol/Spk.svg';
import SymbolStg from '../logos/symbol/Stg.svg';
import SymbolStone from '../logos/symbol/Stone.svg';
import SymbolStrk from '../logos/symbol/Strk.svg';
import SymbolStTao from '../logos/symbol/Sttao.svg';
import SymbolTao from '../logos/symbol/Tao.svg';
import SymbolStx from '../logos/symbol/Stx.svg';
import SymbolSui from '../logos/symbol/Sui.svg';
import SymbolSusde from '../logos/symbol/Susde.svg';
import SymbolUsde from '../logos/symbol/Usde.svg';
import SymbolSusds from '../logos/symbol/Susds.svg';
import SymbolUsds from '../logos/symbol/Usds.svg';
import SymbolSushi from '../logos/symbol/Sushi.svg';
import SymbolSwEth from '../logos/symbol/Sweth.svg';
import SymbolSyrup from '../logos/symbol/Syrup.svg';
import SymbolTaiko from '../logos/symbol/Taiko.svg';
import SymbolTbtc from '../logos/symbol/Tbtc.svg';
import SymbolTia from '../logos/symbol/Tia.svg';
import SymbolTusd from '../logos/symbol/Tusd.svg';
import SymbolTwt from '../logos/symbol/Twt.svg';
import SymbolUltraEths from '../logos/symbol/Ultraeths.svg';
import SymbolUma from '../logos/symbol/Uma.svg';
import SymbolUni from '../logos/symbol/Uni.svg';
import SymbolUniEth from '../logos/symbol/Unieth.svg';
import SymbolUsd1 from '../logos/symbol/Usd1.svg';
import SymbolUsdc from '../logos/symbol/Usdc.svg';
import SymbolUsdp from '../logos/symbol/Usdp.svg';
import SymbolUsdt from '../logos/symbol/Usdt.svg';
import SymbolUsdy from '../logos/symbol/Usdy.svg';
import SymbolVelo from '../logos/symbol/Velo.svg';
import SymbolVet from '../logos/symbol/Vet.svg';
import SymbolVirtual from '../logos/symbol/Virtual.svg';
import SymbolVtho from '../logos/symbol/Vtho.svg';
import SymbolW from '../logos/symbol/W.svg';
import SymbolWbeth from '../logos/symbol/Wbeth.svg';
import SymbolWeEth from '../logos/symbol/Weeth.svg';
import SymbolWeEths from '../logos/symbol/Weeths.svg';
import SymbolWell from '../logos/symbol/Well.svg';
import SymbolWld from '../logos/symbol/Wld.svg';
import SymbolWoo from '../logos/symbol/Woo.svg';
import SymbolWos from '../logos/symbol/Wos.svg';
import SymbolOs from '../logos/symbol/Os.svg';
import SymbolXaut from '../logos/symbol/Xaut.svg';
import SymbolXlm from '../logos/symbol/Xlm.svg';
import SymbolXrp from '../logos/symbol/Xrp.svg';
import SymbolXtz from '../logos/symbol/Xtz.svg';
import SymbolXvs from '../logos/symbol/Xvs.svg';
import SymbolYfi from '../logos/symbol/Yfi.svg';
import SymbolYsUsdc from '../logos/symbol/Ysusdc.svg';
import SymbolYusd from '../logos/symbol/Yusd.svg';
import SymbolZil from '../logos/symbol/Zil.svg';
import SymbolZk from '../logos/symbol/Zk.svg';
import SymbolZrc from '../logos/symbol/Zrc.svg';
import SymbolZro from '../logos/symbol/Zro.svg';
import SymbolZrx from '../logos/symbol/Zrx.svg';
import SymbolPlaceholder from '../logos/symbol/Placeholder.svg';
function sanitizeName(id) {
  return id.replace(/\s+|-/g, '').replace(/ExchangeRate/g, '');
}
function SymbolLogo(id, light = false) {
  if (!id) {
    return SymbolPlaceholder;
  }
  switch (sanitizeName(`${id}${light ? "light" : ""}`).toLowerCase()) {
    case "bnbxlight":
      return SymbolBnbxLight;
    case "ethxlight":
      return SymbolEthxLight;
    case "maticxlight":
      return SymbolMaticxLight;
    case "slight":
      return SymbolSlight;
    case "aave":
      return SymbolAave;
    case "usd":
      return SymbolUsd;
    case "ada":
      return SymbolAda;
    case "aero":
      return SymbolAero;
    case "ageth":
      return SymbolAgEth;
    case "rseth":
      return SymbolRsEth;
    case "algo":
      return SymbolAlgo;
    case "ankr":
      return SymbolAnkr;
    case "ankreth":
      return SymbolAnkrEth;
    case "eth":
      return SymbolEth;
    case "ape":
      return SymbolApe;
    case "api3":
      return SymbolApi3;
    case "apt":
      return SymbolApt;
    case "apxeth":
      return SymbolApxEth;
    case "pxeth":
      return SymbolPxEth;
    case "ar":
      return SymbolAr;
    case "arb":
      return SymbolArb;
    case "astr":
      return SymbolAstr;
    case "atom":
      return SymbolAtom;
    case "ausd":
      return SymbolAusd;
    case "avax":
      return SymbolAvax;
    case "axl":
      return SymbolAxl;
    case "axs":
      return SymbolAxs;
    case "bal":
      return SymbolBal;
    case "band":
      return SymbolBand;
    case "bat":
      return SymbolBat;
    case "bera":
      return SymbolBera;
    case "blast":
      return SymbolBlast;
    case "blur":
      return SymbolBlur;
    case "bnb":
      return SymbolBnb;
    case "bnbx":
      return SymbolBnbx;
    case "brett":
      return SymbolBrett;
    case "btc":
      return SymbolBtc;
    case "cake":
      return SymbolCake;
    case "cbbtc":
      return SymbolCbBtc;
    case "cbeth":
      return SymbolCbEth;
    case "celo":
      return SymbolCelo;
    case "cfx":
      return SymbolCfx;
    case "chz":
      return SymbolChz;
    case "cmeth":
      return SymbolCmEth;
    case "meth":
      return SymbolMeth;
    case "comp":
      return SymbolComp;
    case "cook":
      return SymbolCook;
    case "core":
      return SymbolCore;
    case "cro":
      return SymbolCro;
    case "crv":
      return SymbolCrv;
    case "crvusd":
      return SymbolCrvUsd;
    case "cvx":
      return SymbolCvx;
    case "dai":
      return SymbolDai;
    case "degen":
      return SymbolDegen;
    case "doge":
      return SymbolDoge;
    case "dot":
      return SymbolDot;
    case "dydx":
      return SymbolDydx;
    case "dym":
      return SymbolDym;
    case "ebtc":
      return SymbolEbtc;
    case "wbtc":
      return SymbolWbtc;
    case "egeth":
      return SymbolEgEth;
    case "ena":
      return SymbolEna;
    case "ens":
      return SymbolEns;
    case "ethfi":
      return SymbolEthfi;
    case "ethx":
      return SymbolEthx;
    case "eur":
      return SymbolEur;
    case "eurc":
      return SymbolEurc;
    case "eure":
      return SymbolEure;
    case "ezeth":
      return SymbolEzEth;
    case "fbtc":
      return SymbolFbtc;
    case "fdusd":
      return SymbolFdusd;
    case "fil":
      return SymbolFil;
    case "flow":
      return SymbolFlow;
    case "frax":
      return SymbolFrax;
    case "frxusd":
      return SymbolFrxUsd;
    case "fxs":
      return SymbolFxs;
    case "gho":
      return SymbolGho;
    case "glmr":
      return SymbolGlmr;
    case "gmx":
      return SymbolGmx;
    case "gno":
      return SymbolGno;
    case "gns":
      return SymbolGns;
    case "grt":
      return SymbolGrt;
    case "hbar":
      return SymbolHbar;
    case "hnt":
      return SymbolHnt;
    case "hype":
      return SymbolHype;
    case "icp":
      return SymbolIcp;
    case "imx":
      return SymbolImx;
    case "ineth":
      return SymbolInEth;
    case "inj":
      return SymbolInj;
    case "insfrxeth":
      return SymbolInsfrxEth;
    case "sfrxeth":
      return SymbolSfrxEth;
    case "insteth":
      return SymbolInstEth;
    case "steth":
      return SymbolStEth;
    case "inwsteths":
      return SymbolInwstEths;
    case "wsteth":
      return SymbolWstEth;
    case "joe":
      return SymbolJoe;
    case "kava":
      return SymbolKava;
    case "kda":
      return SymbolKda;
    case "ksm":
      return SymbolKsm;
    case "lbtc":
      return SymbolLbtc;
    case "ldo":
      return SymbolLdo;
    case "link":
      return SymbolLink;
    case "lqty":
      return SymbolLqty;
    case "lseth":
      return SymbolLsEth;
    case "ltc":
      return SymbolLtc;
    case "lumia":
      return SymbolLumia;
    case "lusd":
      return SymbolLusd;
    case "mana":
      return SymbolMana;
    case "manta":
      return SymbolManta;
    case "mask":
      return SymbolMask;
    case "maticx":
      return SymbolMaticx;
    case "matic":
      return SymbolMatic;
    case "merl":
      return SymbolMerl;
    case "metis":
      return SymbolMetis;
    case "mkr":
      return SymbolMkr;
    case "mnt":
      return SymbolMnt;
    case "mode":
      return SymbolMode;
    case "morpho":
      return SymbolMorpho;
    case "movr":
      return SymbolMovr;
    case "msteth":
      return SymbolMstEth;
    case "mtl":
      return SymbolMtl;
    case "mvl":
      return SymbolMvl;
    case "near":
      return SymbolNear;
    case "neon":
      return SymbolNeon;
    case "okb":
      return SymbolOkb;
    case "ondo":
      return SymbolOndo;
    case "op":
      return SymbolOp;
    case "ordi":
      return SymbolOrdi;
    case "oseth":
      return SymbolOsEth;
    case "osmo":
      return SymbolOsmo;
    case "paxg":
      return SymbolPaxg;
    case "pendle":
      return SymbolPendle;
    case "pol":
      return SymbolPol;
    case "pufeth":
      return SymbolPufEth;
    case "pyth":
      return SymbolPyth;
    case "pyusd":
      return SymbolPyusd;
    case "quick":
      return SymbolQuick;
    case "rari":
      return SymbolRari;
    case "rdnt":
      return SymbolRdnt;
    case "render":
      return SymbolRender;
    case "resolv":
      return SymbolResolv;
    case "reth":
      return SymbolReth;
    case "rif":
      return SymbolRif;
    case "ron":
      return SymbolRon;
    case "rose":
      return SymbolRose;
    case "rpl":
      return SymbolRpl;
    case "rsr":
      return SymbolRsr;
    case "rsweth":
      return SymbolRswEth;
    case "rune":
      return SymbolRune;
    case "s":
      return SymbolS;
    case "safe":
      return SymbolSafe;
    case "sand":
      return SymbolSand;
    case "sats":
      return SymbolSats;
    case "savax":
      return SymbolSavax;
    case "scr":
      return SymbolScr;
    case "scrvusd":
      return SymbolScrvUsd;
    case "sdai":
      return SymbolSdai;
    case "sei":
      return SymbolSei;
    case "sfrax":
      return SymbolSfrax;
    case "frxeth":
      return SymbolFrxEth;
    case "sfrxusd":
      return SymbolSfrxUsd;
    case "shib":
      return SymbolShib;
    case "slisbnb":
      return SymbolSlisBnb;
    case "snx":
      return SymbolSnx;
    case "sol":
      return SymbolSol;
    case "solvbtc":
      return SymbolSolvBtc;
    case "spk":
      return SymbolSpk;
    case "stg":
      return SymbolStg;
    case "stone":
      return SymbolStone;
    case "strk":
      return SymbolStrk;
    case "sttao":
      return SymbolStTao;
    case "tao":
      return SymbolTao;
    case "stx":
      return SymbolStx;
    case "sui":
      return SymbolSui;
    case "susde":
      return SymbolSusde;
    case "usde":
      return SymbolUsde;
    case "susds":
      return SymbolSusds;
    case "usds":
      return SymbolUsds;
    case "sushi":
      return SymbolSushi;
    case "sweth":
      return SymbolSwEth;
    case "syrup":
      return SymbolSyrup;
    case "taiko":
      return SymbolTaiko;
    case "tbtc":
      return SymbolTbtc;
    case "tia":
      return SymbolTia;
    case "tusd":
      return SymbolTusd;
    case "twt":
      return SymbolTwt;
    case "ultraeths":
      return SymbolUltraEths;
    case "uma":
      return SymbolUma;
    case "uni":
      return SymbolUni;
    case "unieth":
      return SymbolUniEth;
    case "usd1":
      return SymbolUsd1;
    case "usdc":
      return SymbolUsdc;
    case "usdp":
      return SymbolUsdp;
    case "usdt":
      return SymbolUsdt;
    case "usdy":
      return SymbolUsdy;
    case "velo":
      return SymbolVelo;
    case "vet":
      return SymbolVet;
    case "virtual":
      return SymbolVirtual;
    case "vtho":
      return SymbolVtho;
    case "w":
      return SymbolW;
    case "wbeth":
      return SymbolWbeth;
    case "weeth":
      return SymbolWeEth;
    case "weeths":
      return SymbolWeEths;
    case "well":
      return SymbolWell;
    case "wld":
      return SymbolWld;
    case "woo":
      return SymbolWoo;
    case "wos":
      return SymbolWos;
    case "os":
      return SymbolOs;
    case "xaut":
      return SymbolXaut;
    case "xlm":
      return SymbolXlm;
    case "xrp":
      return SymbolXrp;
    case "xtz":
      return SymbolXtz;
    case "xvs":
      return SymbolXvs;
    case "yfi":
      return SymbolYfi;
    case "ysusdc":
      return SymbolYsUsdc;
    case "yusd":
      return SymbolYusd;
    case "zil":
      return SymbolZil;
    case "zk":
      return SymbolZk;
    case "zrc":
      return SymbolZrc;
    case "zro":
      return SymbolZro;
    case "zrx":
      return SymbolZrx;
    default:
      return light ? SymbolLogo(id) : SymbolPlaceholder;
  }
}
export default SymbolLogo;